export const BUTTON_EDGE_OFFSET = 36;
export const SMALL_DEVICE_WIDTH = 768;
export const DEFAULT_CHAT_WIDTH = 400;
export const DEFAULT_CHAT_HEIGHT = 600;
// Launcher colour used before the tenant config arrives from the chat iframe.
// Matches the fallback palette primaryMain in libs/config-provider defaults.
export const DEFAULT_LAUNCHER_COLOUR = '#1565c0';
